import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appConfig: null,
    qmUserToken: null,
    memberCoupon: null,
    uuid: null,
    orderId: null,
  },
  mutations: {
    SET_APP_CONFIG(state, config) {
      state.appConfig = config
    },
    SET_QM_USER_TOKEN(state, qmUserToken) {
      state.qmUserToken = qmUserToken;
    },
    SET_MEMBER_COUPON(state, coupon) {
      state.memberCoupon = coupon;
    },
    SET_UUID(state, uuid) {
      state.uuid = uuid;
    },
    SET_ORDER_ID(state, orderId) {
      state.orderId = orderId;
    },
    CLEAR_QM_USER_TOKEN(state) {
      state.qmUserToken = null;
    },
    CLEAR_MEMBER_COUPON(state) {
      state.memberCoupon = null;
    },
    CLEAR_UUID(state) {
      state.uuid = null;
    },
    CLEAR_ORDER_ID(state) {
      state.orderId = null;
    },
  },
  actions: {
    setQmUserToken({ commit }, qmUserToken) {
      commit('SET_QM_USER_TOKEN', qmUserToken);
    },
    setMemberCoupon({ commit }, coupon) {
      commit('SET_MEMBER_COUPON', coupon);
    },
    setUuid({ commit }, uuid) {
      commit('SET_UUID', uuid);
    },
    setOrderId({ commit }, orderId) {
      commit('SET_ORDER_ID', orderId);
    },
    clearQmUserToken({ commit }) {
      commit('CLEAR_QM_USER_TOKEN');
    },
    clearMemberCoupon({ commit }) {
      commit('CLEAR_MEMBER_COUPON');
    },
    clearUuid({ commit }) {
      commit('CLEAR_UUID');
    },
    clearOrderId({ commit }) {
      commit('CLEAR_ORDER_ID');
    },
  },
  getters: {
    // 从 orderId 中提取手机号
    phoneNumber(state) {
      if (!state.orderId) return null;
      // orderId 格式: "wxid_xxx|18083666584"
      const parts = state.orderId.split('|');
      return parts.length > 1 ? parts[1] : null;
    }
  },
  modules: {
  },
  plugins: [createPersistedState()]
}) 